var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "detail-store-based-marketing-title" },
      [_c("CustomBreadcrumb")],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "detail-title" }, [
      _vm._v(_vm._s(_vm.campaignName))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "detail-tabs" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.selectedTab,
              callback: function($$v) {
                _vm.selectedTab = $$v
              },
              expression: "selectedTab"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "Open Rate (" + _vm.openRatePercent + ")",
                  name: "openRate"
                }
              },
              [_c("OpenRate", { ref: "openRate" })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "Click Rate (" + _vm.clickRatePercent + ")",
                  name: "clickRate"
                }
              },
              [_c("ClickRate", { ref: "clickRate" })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "View Product (" + _vm.viewProductPercent + ")",
                  name: "viewProduct"
                }
              },
              [_c("ViewProduct", { ref: "viewProduct" })],
              1
            ),
            _vm._v(" "),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "Add to cart (" + _vm.addToCartPercent + ")",
                  name: "addToCart"
                }
              },
              [_c("AddToCart", { ref: "addToCart" })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36595e31", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36595e31","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/store-based-marketing/store-based-marketing-detail.vue
// module id = fQrI
// module chunks = 2